import { get, post } from 'api/request';
import urls from 'configs/urls';

export const authenticateUser = ({ data }) =>
  post(null, true, urls.accountManagementUrls.authenticateUser, data);

export const getLoginInfo = ({ userKey }) =>
  get(null, false, `${urls.accountManagementUrls.getLoginInfo}/${userKey}`);
